import { createAsyncThunk } from "@reduxjs/toolkit";
import { AuthApi } from "api/auth";
import { ResponseEnum } from "enums/response";
import { getMemberBalance, getProfile } from "store/user/user.thunk";
import { LoginFormType, RecoveryFormType, RegisterFormType } from "types/auth";

export const signInWithCredentials = createAsyncThunk(
  "auth/signInWithCredentials",
  async (formData: Omit<LoginFormType, "isRemember">, thunkApi) => {
    try {
      const dataAuth = await AuthApi.login(formData.username, formData);

      if (dataAuth.msg === "Success") {
        const { dispatch } = thunkApi;
        dispatch(getMemberBalance({ username: formData.username }));
        dispatch(getProfile(formData.username));
        return dataAuth;
      }

      return dataAuth;
    } catch (error) {
      thunkApi.rejectWithValue(error);
    }
  }
);

export const verifyToken = createAsyncThunk(
  "auth/verifyToken",
  async (
    { username, token }: { username: string; token: string },
    { rejectWithValue }
  ) => {
    try {
      const { status } = await AuthApi.verifyToken(username, {
        username,
        token,
      });
      if (status !== ResponseEnum.statusSuccess) {
        return "";
      }
      return username;
    } catch (error) {
      rejectWithValue(error);
    }
  }
);

export const signUpWithCredentials = createAsyncThunk(
  "auth/signUpWithCredentials",
  async (formData: RegisterFormType, thunkApi) => {
    try {
      const response = await AuthApi.register(formData.username, formData);

      if (response.msg !== ResponseEnum.msgSuccess) {
        return response;
      }

      const { dispatch } = thunkApi;

      dispatch(
        signInWithCredentials({
          username: formData.username,
          password: formData.password,
        })
      );

      return response;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  }
);

export const recoveryPassword = createAsyncThunk(
  "auth/recovery",
  async (formData: RecoveryFormType, { rejectWithValue }) => {
    try {
      const res = await AuthApi.recovery(formData.username, formData);
      return res;
    } catch (error) {
      rejectWithValue(error);
    }
  }
);
